import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { authClient } from "@/client/lib/auth-client";

/** The fields Better Auth's provider makes public for an assistant, in OAuth's own names. */
const publicClient = z.object({
  client_id: z.string(),
  client_name: z.string().optional(),
  logo_uri: z.string().optional(),
});

export type PublicClient = z.infer<typeof publicClient>;

export const consentClientQuery = (clientId: string) =>
  queryOptions({
    queryKey: ["oauth-client", clientId],
    queryFn: async (): Promise<PublicClient> => {
      const auth = await authClient();
      const { data, error } = await auth.$fetch("/oauth2/public-client", {
        method: "GET",
        query: { client_id: clientId },
      });
      if (error) throw new Error(error.message ?? error.statusText);
      return publicClient.parse(data);
    },
  });
